import api from './api';

// PM analitik P6 — E13 Sürekli geri bildirim analitiği. Uçlar backend PerformanceFeedbackAnalyticsController'ın aynasıdır
// ([Route("v1/performance-feedback-analytics")]). Yalnız sayılar ve kayıt üst verisi döner: geri bildirim metni, anonim
// gönderici, talep mesajı ve 1:1 içeriği hiçbir uçta yoktur. 1:1 sayıları kiracı ayarıyla (yalnız İK değiştirir).
const BASE = '/v1/performance-feedback-analytics';
const TEAM_VIEW_DISABLED = 'performance.feedbackAnalytics.teamViewDisabled';

export const getFeedbackSummary = (params) => api.get(`${BASE}/summary`, { params });
export const getFeedbackMonthly = (params) => api.get(`${BASE}/monthly`, { params });
export const getFeedbackTopics = (params) => api.get(`${BASE}/topics`, { params });
export const getFeedbackBreakdown = (params) => api.get(`${BASE}/breakdown`, { params });

// Yöneticinin "ekibin geri bildirimlerini görür" ayarı kapalıysa sunucu 409 döner: bilinen bir durumdur (tost yok), sayfa
// kendi açıklamasını gösterir.
export const getFeedbackRecords = (params) => api.get(`${BASE}/records`, {
  params, passErrorBody: true, skipErrorToast: [TEAM_VIEW_DISABLED],
});
export const TEAM_VIEW_DISABLED_KEY = TEAM_VIEW_DISABLED;

export const getFeedbackAnalyticsSettings = () => api.get(`${BASE}/settings`);
export const updateFeedbackAnalyticsSettings = (payload) => api.put(`${BASE}/settings`, payload);
